module.exports = __webpack_public_path__ + "img/closed-loop-1.c3e55e06.png";